import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowRight } from '@fortawesome/pro-light-svg-icons/faLongArrowRight';
import { faMemoCircleInfo } from '@fortawesome/pro-light-svg-icons/faMemoCircleInfo';
import clsx from 'clsx';
import { Tooltip } from 'Tooltip';
import { parseHtml } from 'FrontRoyalAngular/html.utils';
import { linkStyles } from './shared';

type Props = {
    url: string;
    title: string;
    fullWidth?: boolean;
    className?: string;
    canLaunch?: boolean;
    reasonMessage?: string | null;
};

function getSharedClassNames(fullWidth: boolean) {
    return clsx('flex items-start gap-[5px]', fullWidth ? 'col-span-2' : 'col-[right-col] max-sm:pl-2');
}

function SourceLinkBody({ fullWidth, title }: { fullWidth: boolean; title: string }) {
    return (
        <>
            {/* When a link is not "fullWidth", then it is part of a section. The arrow
                connects it with the section, which has it's own link on the left. */}
            {!fullWidth && (
                <FontAwesomeIcon
                    className="fa-width-auto inline-block shrink-0 grow-0 text-xs text-tutorbot-chat max-sm:pe-2 sm:px-2 rtl:-scale-x-100"
                    icon={faLongArrowRight}
                />
            )}
            {/* When the link is full width, it is not part of a section, so we replace the
                arrow with a generic faMemoCircleInfo */}
            {fullWidth && (
                <FontAwesomeIcon
                    className="fa-width-auto inline-block shrink-0 grow-0 px-1 pl-[2px] text-md text-tutorbot-chat"
                    icon={faMemoCircleInfo}
                />
            )}
            {title}
        </>
    );
}

export default function SourceLink({
    url,
    title,
    fullWidth = false,
    className = '',
    canLaunch = true,
    reasonMessage = null,
}: Props) {
    return (
        <>
            {canLaunch ? (
                <a
                    data-testid="lesson-link"
                    href={url}
                    target="_blank"
                    rel="noreferrer"
                    className={clsx(getSharedClassNames(fullWidth), linkStyles, className)}
                >
                    <SourceLinkBody fullWidth={fullWidth} title={title} />
                </a>
            ) : (
                <Tooltip content={<span className="whitespace-nowrap">{parseHtml(reasonMessage ?? '')}</span>}>
                    <span
                        className={clsx(
                            getSharedClassNames(fullWidth),
                            'text-slate-grey-600',
                            'cursor-not-allowed',
                            className,
                        )}
                        data-testid="lesson-link-locked"
                    >
                        <SourceLinkBody fullWidth={fullWidth} title={title} />
                    </span>
                </Tooltip>
            )}
        </>
    );
}
